import { render, staticRenderFns } from "./details.vue?vue&type=template&id=21e14fba&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style1 from "./details.vue?vue&type=style&index=1&id=21e14fba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e14fba",
  null
  
)

export default component.exports